import React, { useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";

function Navbar() {
  const [visibleRight, setVisibleRight] = useState(false);
  const customIcon = (
    <React.Fragment>
      <img className="p-icon" alt="close icon" src="/images/closeicon.svg" />
    </React.Fragment>
  );
  const handleLinkClick = () => {
    setVisibleRight(false); // Close the sidebar when a link is clicked
  };
  return (
    <div className="navbar-container">
      <div className="desktop-version" id="navbardesktop">
        <div className="navbar-logo">
          <Link to="/">
            <img src="/images/logo.png" alt="Medical Logo" />
          </Link>
        </div>
        <div className="navbar-links">
          <Link to="/">HOME</Link>
          <Link to="/productsByBrand">PRODUCTS</Link>
          <Link to="/contact">CONTACT US</Link>
        </div>
      </div>
      <div className="navbar-mobile-version">
        <div className="right-menu-bar">
          <Link to="/">
            <img
              src="/images/logo.png" // Replace with the actual path to your image
              alt="Menu Icon"
              className="menu-icon"
              // onClick={() => setVisibleRight(true)}
              style={{ cursor: "pointer", width: "50px" }} // Adjust styling as needed
            />
          </Link>
          <Button onClick={() => setVisibleRight(true)}>
            <img
              src="/images/menuicon.png"
              alt="Custom Menu"
              className="custom-menu-icon"
              width={30}
            />
          </Button>
          <Sidebar
            className="menubar-mobile"
            visible={visibleRight}
            position="right"
            onHide={() => setVisibleRight(false)}
            closeIcon={customIcon}
          >
            <div className="right-side-bar">
              <Link to="/" onClick={handleLinkClick}>
                HOME
              </Link>
              <Link to="/productsByBrand" onClick={handleLinkClick}>
                PRODUCT
              </Link>
              <Link to="/contact" onClick={handleLinkClick}>
                CONTACT
              </Link>
            </div>
          </Sidebar>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
